module.exports = __webpack_public_path__ + "img/e15e4c7.jpg";